import React from 'react';
import { Box, Typography } from '@mui/material';

const Configuration: React.FC = () => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4">Planner (Coming Soon)</Typography>
    </Box>
  );
};

export default Configuration;
